<script>
import snackbarMixin from '@/mixins/snackbar';
import reloginMixin from '@/mixins/relogin';
import { rbxAuthToken } from '../../../config';

export default {
  name: 'ClientListItem',
  mixins: [snackbarMixin, reloginMixin],
  props: {
    client: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    onDelete() {
      this.$emit('delete', this.client);
    },
    onLogin() {
      this.relogin(this.client.resellerUser, rbxAuthToken);
    },
  },
};
</script>

<template>
  <tr>
    <td>
      <v-tooltip bottom>
        <v-btn @click.native="onLogin" flat icon slot="activator" :disabled="client.isDelete">
          <v-icon small>arrow_forward</v-icon>
        </v-btn>
        <span>Einloggen</span>
      </v-tooltip>
    </td>
    <td><router-link :to="`/client/show/${client.id}`">{{ client.name }}</router-link></td>
    <td>{{ client.isDemo ? 'ja' : 'nein' }}</td>
    <td>{{ client.isDemo ? (client.remainingDemoDays && client.remainingDemoDays > 0 ? '' + client.remainingDemoDays + ' Tage' : 'Demo abgelaufen') : '' }}</td>  <!-- eslint-disable-line -->
    <td>{{ client.isActive ? 'ja' : 'nein' }}</td>
    <td>{{ client.resellerUser }}</td>
    <td>
      <v-tooltip bottom>
        <v-btn @click.native="onDelete" flat icon slot="activator" :disabled="client.isDelete">
          <v-icon small>delete</v-icon>
        </v-btn>
        <span>Löschen</span>
      </v-tooltip>
    </td>
  </tr>
</template>
